module.exports = __webpack_public_path__ + "static/senseur-pluie-b44cee26707728f3108d11a439a70147.webm";